const record = (v) => typeof v === 'object' && v !== null;
const category = (v) => record(v) &&
    ['id', 'code', 'name'].every((k) => typeof v[k] === 'string') &&
    typeof v.active === 'boolean';
const concept = (v, org) => record(v) &&
    v.organizationId === org &&
    ['id', 'code', 'name', 'description', 'createdAt', 'updatedAt'].every((k) => typeof v[k] === 'string') &&
    ['standard', 'regularization_contribution'].includes(String(v.kind)) &&
    typeof v.active === 'boolean' &&
    Number.isInteger(v.version) &&
    Number(v.version) > 0 &&
    category(v.category);
const envelope = (v, org) => record(v) && v.schemaVersion === 1 && v.testOnly === true && v.organizationId === org;
export function isInstitutionalConceptsResponse(v, org) {
    return (envelope(v, org) &&
        Array.isArray(v.items) &&
        v.items.every((c) => concept(c, org)) &&
        Array.isArray(v.categories) &&
        v.categories.every(category));
}
export function isInstitutionalConceptResponse(v, org) {
    return envelope(v, org) && concept(v.concept, org);
}
